export default __webpack_public_path__ + "static/media/05.8cb5e24a.jpg";